<template>
  <div class="room-setting-menu-component">
    <div class="room-setting-menu-wrapper">
      <button
        v-for="menu in menuList"
        :key="menu.type" class="room-setting-menu-item"
        :class="[{ selected : isSelected == menu.type }, menu.type]"
        :name="menu.type"
        :title="menu.name"
        :aria-label="menu.name"
        tabindex="3"
        @click="onClickMenu($event)"
      >
        <span class="room-setting-menu-icon"></span>
        <span class="room-setting-menu-tx">{{ menu.name }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  emits: ['changeMenu'],
  data(){
    return{
      isSelected : ''
    }
  },
  computed:{
    ...mapGetters('user', [
      'hasEmceeRole'
    ]),
    ...mapGetters('room',[
       'isEdu'
    ]),
    ...mapGetters('roomSetting',[
       'roomSetting'
    ]),
    menuList(){
      let menuList =  [
        {type: 'general', name: this.$t('setting.general.title')},
        {type: 'join', name: this.$t('setting.join.title')},
        {type: 'quality', name: this.$t('setting.quality.title')},
        {type: 'chat', name: this.$t('setting.chat.title')},
        {type: 'display', name: this.$t('setting.display')},
        {type: 'group', name: this.$t('setting.group.title')},
        {type: 'share', name: this.$t('setting.share.title')},
        {type: 'etc', name: this.$t('setting.etc.title')}
      ]
      if(this.roomSetting && !this.roomSetting.adjustVideoQuality) {
        menuList = menuList.filter(menu => menu.type !=='quality')
      }
      if(!this.hasEmceeRole()) {
        return menuList.filter(menu => menu.type ==='etc')
      }

      if(!this.isEdu) {
        return menuList.filter(menu => menu.type !=='group')
      }

      return menuList
    }
  },
  created() {
    this.initSelectedMenu();
  },
  methods: {
    initSelectedMenu(){
      this.isSelected = this.hasEmceeRole() ? 'general' : 'etc'
    },
    onClickMenu(event){
      this.isSelected = event.target.name
      this.$emit('changeMenu', this.isSelected)
    }
  }
}
</script>

<style lang='scss' scoped>
  .room-setting-menu-component{
    background-color: #eee;

    .room-setting-menu-wrapper{
      height: 100%;
      overflow: auto;
    }

    .room-setting-menu-item {
      display: flex;
      align-items: center;
      width: 120px;
      padding: 12px 20px 12px 16px;

      .room-setting-menu-icon {
        display: block;
        min-width: 16px;
        width: 16px;
        height: 16px;
        opacity: 0.3;
        pointer-events: none;
      }
      .room-setting-menu-tx{
        text-align: left;
        margin-left: 12px;
        font-size: 15px;
        color: #b5b5b5;
        pointer-events: none;
      }

      &.general .room-setting-menu-icon {
        background: url('~@/assets/images/set_general.svg') no-repeat center / auto 100%;
      }

      &.join .room-setting-menu-icon {
        background: url('~@/assets/images/set_join.svg') no-repeat center / auto 100%;
      }

      &.quality .room-setting-menu-icon {
        background: url('~@/assets/images/set_quality.svg') no-repeat center / auto 100%;
      }

      &.chat .room-setting-menu-icon {
        background: url('~@/assets/images/set_chat.svg') no-repeat center / auto 100%;
      }

      &.display .room-setting-menu-icon {
        background: url('~@/assets/images/set_display.svg') no-repeat center / auto 100%;
      }

      &.group .room-setting-menu-icon {
        background: url('~@/assets/images/set_group.svg') no-repeat center / auto 100%;
      }

      &.share .room-setting-menu-icon {
        background: url('~@/assets/images/set_share.svg') no-repeat center / auto 100%;
      }

      &.etc .room-setting-menu-icon {
        background: url('~@/assets/images/set_more.svg') no-repeat center / auto 100%;
      }

      &:hover{
        background-color: white;
      }

      &.selected{
        background-color: white;


        .room-setting-menu-icon {
          opacity: 0.8;
        }

        .room-setting-menu-tx {
          color: #333;
          font-weight: bold;
        }
      }
    }
  }
  [grm-device-mobile]{
      .room-setting-menu-item{
        max-width: 120px;
      }
  }
</style>